import { VBPopover } from './popover'
import { pluginFactory } from '../../utils/plugins'

const VBPopoverPlugin = /*#__PURE__*/ pluginFactory({
  directives: { VBPopover }
})

export { VBPopoverPlugin, VBPopover }

export default VBPopoverPlugin
